module.exports = __webpack_public_path__ + "img/check_in.36331651.png";